import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@/common/auth/auth-session.service';
import { Injectable } from '@angular/core';
import { first, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PublicGuard {
  constructor(
		private sessionService: SessionService,
    private router: Router
  ) {}

	canActivate: CanActivateFn = () => {
    return this.sessionService.authCheck().pipe(
			first(),
      map(isAuthenticated => {
        if (isAuthenticated) {
          this.router.navigate(['/projects']);
					return false;
        } else {
          return true;
        }
      })
    );
  }
}
